import { render, staticRenderFns } from "./AppProfileStepCompany.vue?vue&type=template&id=0047b0e4&scoped=true&"
import script from "./AppProfileStepCompany.vue?vue&type=script&lang=ts&"
export * from "./AppProfileStepCompany.vue?vue&type=script&lang=ts&"
import style0 from "./AppProfileStepCompany.vue?vue&type=style&index=0&id=0047b0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047b0e4",
  null
  
)

export default component.exports